import { render, staticRenderFns } from "./FAQContent.vue?vue&type=template&id=18b683ee&scoped=true&"
import script from "./FAQContent.vue?vue&type=script&lang=js&"
export * from "./FAQContent.vue?vue&type=script&lang=js&"
import style0 from "./FAQContent.vue?vue&type=style&index=0&id=18b683ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b683ee",
  null
  
)

export default component.exports